import { Response, apiAbortController } from '@ui/src';
import api from '../../../../api/api';
import { CountryItem } from '../../types';

export const countriesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEmployeesCountries: build.query<Response<CountryItem>, string>({
      query: (cursor) => ({
        url: `/v1/countries${cursor}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getCountry: build.query<{ data: CountryItem }, string>({
      query: (id) => ({
        url: `/v1/countries/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getCountActiveCountries: build.query<Response<CountryItem>, void>({
      query: () => ({
        url: `/v1/countries?active=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateCountryRiskScore: build.mutation<
      {
        data: CountryItem;
      },
      {
        id: string;
        body: {
          riskScore: number;
        };
      }
    >({
      query: (data) => ({
        url: `/v1/countries/${data.id}/risk-score`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateCountryActivity: build.mutation<
      {
        data: CountryItem;
      },
      {
        id: string;
        body: {
          active: boolean;
        };
      }
    >({
      query: (data) => ({
        url: `/v1/countries/${data.id}/active`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    toggleCountriesActive: build.mutation<
      {
        data: CountryItem;
      },
      { active: boolean; ids: string[] }
    >({
      query: (data: { active: boolean; ids: string[] }) => ({
        url: `/v1/countries/batch-status`,
        method: 'PUT',
        body: {
          active: data.active,
          ids: data.ids,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetEmployeesCountriesQuery,
  useLazyGetCountActiveCountriesQuery,
  useToggleCountriesActiveMutation,
  useLazyGetCountryQuery,
  useUpdateCountryRiskScoreMutation,
  useUpdateCountryActivityMutation,
} = countriesApi;

export const {
  endpoints: {
    getEmployeesCountries,
    toggleCountriesActive,
    getCountActiveCountries,
    updateCountryRiskScore,
    getCountry,
    updateCountryActivity,
  },
} = countriesApi;
